import { Component, lazy, Suspense } from 'react';
import { NavMarker } from 'react-rhumb';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import ViewContainerContext from '../../containers/ViewContainerContext';
import { isChirpEnabled } from '../../utils/isChirpEnabled';
import { isHtmlRenderMode } from '../../utils/isHtmlRenderMode';
import ViewToolbar from './ViewToolbar';
import ViewContent from './ViewContent';
import PreviewAlert from './PreviewAlert';
import UTMBanner from './UTMBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerInfoModal = /*#__PURE__*/lazy(() => import('./ViewerInfoModal').then(m => ({
  default: m.ViewerInfoModal
})));
export default class PublicView extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      pageDrawerOpen: true,
      viewerInfoSubmitted: false
    };
    this.handlePageDrawerToggle = () => {
      this.setState(({
        pageDrawerOpen
      }) => ({
        pageDrawerOpen: !pageDrawerOpen
      }));
    };
    this.handleViewerInfoSubmit = viewerInfo => {
      const {
        onIdentifyViewer,
        onIdentifySharedLinkViewer,
        presentation,
        sharedLink
      } = this.props;
      const isUngatedToChirp = isChirpEnabled();
      if (isUngatedToChirp) {
        onIdentifySharedLinkViewer(sharedLink, viewerInfo);
      } else {
        onIdentifyViewer(presentation, viewerInfo);
      }
      this.setState({
        viewerInfoSubmitted: true
      });
    };
    this.renderPreviewAlert = () => {
      const context = this.context;
      if (!context.isPreview) {
        return null;
      }
      const {
        presentation,
        sharedLink
      } = this.props;
      const isUngatedToChirp = isChirpEnabled();
      const deckId = isUngatedToChirp ? sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.id : presentation === null || presentation === void 0 ? void 0 : presentation.id;
      return /*#__PURE__*/_jsx(View, {
        "data-test-id": "preview-alert",
        padding: "400",
        children: /*#__PURE__*/_jsx(PreviewAlert, {
          deckId: deckId
        })
      });
    };
    this.renderUTM = () => {
      var _sharedLink$brandingM, _presentation$brandin;
      const {
        presentation,
        sharedLink
      } = this.props;
      const brandingShowSalesAd = sharedLink ? (_sharedLink$brandingM = sharedLink.brandingMetadata) === null || _sharedLink$brandingM === void 0 ? void 0 : _sharedLink$brandingM.showSalesAd : presentation === null || presentation === void 0 || (_presentation$brandin = presentation.brandingMetadata) === null || _presentation$brandin === void 0 ? void 0 : _presentation$brandin.showSalesAd;
      if (!brandingShowSalesAd) {
        return null;
      }
      return /*#__PURE__*/_jsx(UTMBanner, {});
    };
  }
  componentDidMount() {
    const context = this.context;
    const {
      isPreview
    } = context;
    const {
      onIdentifyViewer,
      onIdentifySharedLinkViewer,
      onFinishActivity,
      onFinishSessionCHIRP,
      presentation,
      sharedLink,
      requiresViewerInfo
    } = this.props;
    if (!isPreview) {
      window.onbeforeunload = () => {
        const isUngatedToChirp = isChirpEnabled();
        if (isUngatedToChirp) {
          onFinishSessionCHIRP({
            pageNumber: this.props.pageNumber
          });
        } else {
          onFinishActivity();
        }
      };
      if (!requiresViewerInfo) {
        const isUngatedToChirp = isChirpEnabled();
        if (isUngatedToChirp) {
          onIdentifySharedLinkViewer(sharedLink);
        } else {
          onIdentifyViewer(presentation);
        }
      }
    }
  }
  render() {
    var _firstName, _lastName;
    const {
      presentation,
      sharedLink,
      meetingLink,
      fetchDownloadLink,
      onDownloadCHIRP,
      requiresViewerInfo,
      legalConsent,
      legalConsentCHIRP
    } = this.props;
    const {
      pageDrawerOpen,
      viewerInfoSubmitted
    } = this.state;
    const isUngatedToChirp = isChirpEnabled();
    const isHtmlDocument = isUngatedToChirp && isHtmlRenderMode(sharedLink);
    const {
      givenName,
      familyName,
      accessId,
      presentationId,
      pdfUrl
    } = isUngatedToChirp ? {
      givenName: (_firstName = (sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.user).firstName) !== null && _firstName !== void 0 ? _firstName : null,
      familyName: (_lastName = (sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.user).lastName) !== null && _lastName !== void 0 ? _lastName : null,
      accessId: sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.accessId,
      presentationId: sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.id,
      pdfUrl: sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.pdfUrl
    } : {
      givenName: (presentation === null || presentation === void 0 ? void 0 : presentation.user).firstName,
      familyName: (presentation === null || presentation === void 0 ? void 0 : presentation.user).lastName,
      accessId: presentation === null || presentation === void 0 ? void 0 : presentation.accessId,
      presentationId: presentation === null || presentation === void 0 ? void 0 : presentation.id,
      pdfUrl: presentation === null || presentation === void 0 ? void 0 : presentation.pdfUrl
    };
    return /*#__PURE__*/_jsxs(Flex, {
      "data-test-id": "public-view",
      flexDirection: "column",
      position: "relative",
      blockSize: "100%",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "PREVIEW_LOAD"
      }), requiresViewerInfo && !viewerInfoSubmitted && /*#__PURE__*/_jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/_jsx(ViewerInfoModal, {
          legalConsent: legalConsent,
          legalConsentCHIRP: legalConsentCHIRP,
          givenName: givenName,
          familyName: familyName,
          accessId: accessId,
          presentationId: presentationId,
          onConfirm: viewerInfo => this.handleViewerInfoSubmit(viewerInfo)
        })
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          position: 'relative'
        },
        children: [/*#__PURE__*/_jsx("div", {
          id: "public-view-fire-alarm-container"
        }), /*#__PURE__*/_jsx(ViewToolbar, {
          presentation: presentation,
          sharedLink: sharedLink,
          meetingLink: meetingLink,
          fetchDownloadLink: fetchDownloadLink,
          onDownloadCHIRP: onDownloadCHIRP,
          onPageDrawerToggle: this.handlePageDrawerToggle,
          isHtmlDocument: isHtmlDocument
        })]
      }), this.renderPreviewAlert(), /*#__PURE__*/_jsx(ViewContent, {
        presentation: presentation,
        sharedLink: sharedLink,
        file: pdfUrl,
        pageDrawerOpen: pageDrawerOpen,
        isHtmlDocument: isHtmlDocument
      }), this.renderUTM()]
    });
  }
}
PublicView.contextType = ViewContainerContext;